import { render, staticRenderFns } from "./RegionalMemos.vue?vue&type=template&id=4969a69c&scoped=true"
import script from "./RegionalMemos.vue?vue&type=script&lang=js"
export * from "./RegionalMemos.vue?vue&type=script&lang=js"
import style0 from "./RegionalMemos.vue?vue&type=style&index=0&id=4969a69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969a69c",
  null
  
)

export default component.exports